/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Nav_GroupInputs */

const en_directory_nav_group = /** @type {(inputs: Directory_Nav_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groups`)
};

const zh_directory_nav_group = /** @type {(inputs: Directory_Nav_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分组`)
};

/**
* | output |
* | --- |
* | "Groups" |
*
* @param {Directory_Nav_GroupInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_nav_group = /** @type {((inputs?: Directory_Nav_GroupInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Nav_GroupInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_nav_group(inputs)
	return zh_directory_nav_group(inputs)
});
export { directory_nav_group as "directory.nav.group" }